<template>
    <div>
        <component v-bind:is="layout" v-cloak v-if="layout"></component>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { store } from '@/store'

import patientRepository from './data/PatientRepository'

import PatientLayout from './layouts/PatientLayout'
import DoctorLayout from './layouts/DoctorLayout'

export default {
    name: 'App',

    computed: {
        layout () {
            return this.$store.getters.layout
        }
    },

    components: { PatientLayout, DoctorLayout },

    mounted () {
        this.checkOnlineStatus()
        window.addEventListener('online', this.checkOnlineStatus)
        window.addEventListener('offline', this.checkOnlineStatus)

        firebase.auth().getRedirectResult().then((result) => {
            if (result && result.user) {
                if (this.layout == 'PatientLayout') {
                    // Patient does not exist
                    patientRepository.createOrUpdate(result.user, (patient) => {
                        store.dispatch('setPatient', patient)
                    }, (error) => {
                        // Could not create patient
                        console.error(error)
                    })
                    // this.$router.push('/');
                } else if (this.layout == 'DoctorLayout') {
                    this.$router.push({name: 'doctor.dashboard'});
                }
            }
        }).catch((error) => {
            this.$store.dispatch('setFormError', error.message)
        })
    },

    methods: {
        checkOnlineStatus () {
            if (typeof window.navigator.onLine === 'undefined') {
                this.$store.commit('SET_ONLINE', true)
            } else {
                this.$store.commit('SET_ONLINE', window.navigator.onLine)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/App.vue